<ui-app-shell>
  <ui-sidenav
    [sections]="sections()"
    [footerLinks]="footerLinks()"
    brandRoute="/"
    brandLabel="Halio Admin home"
  >
    <!-- Square "h" monogram for the icon rail. Drawn to match the halio.ai
         wordmark (heavy geometric sans, flat terminals) because there is no
         square brand asset; inline so it can follow currentColor rather than
         needing a dark-mode invert like the wordmark PNG. -->
    <svg
      uiSidenavBrandMark
      class="brand-mark"
      viewBox="0 0 32 32"
      fill="none"
      stroke="currentColor"
      stroke-width="6.2"
      aria-hidden="true"
    >
      <path d="M9.6 4.6V27.4M9.6 19.2a6.2 6.2 0 0 1 12.4 0v8.2" />
    </svg>

    <span uiSidenavBrandName class="brand-full">
      <img class="brand-logo" src="halio-logo.png" alt="Halio" />
      <span class="brand-app">Admin</span>
    </span>

    <ui-back-to-app uiSidenavFooter [href]="usersAppUrl" label="Back to Halio" />
    <ui-theme-toggle uiSidenavFooter />
  </ui-sidenav>

  <span uiShellTitle>Admin</span>

  <router-outlet />
</ui-app-shell>
